<template>
    <!--  서브페이지  -->

    <!--콘텐츠 영역-->
    <div id="sub_contents" class="sub_contents">

        <a @click="btnNoticeWrite" v-if="isAdmin" class="admin writing"
            >소식 추가</a>

        <!-- <router-link v-if="isAdmin" class ="admin writing" to="/notice/bannerList">배너 이동</router-link> -->

        <div class="News_list">
          <ul class="list">
            <li v-for="(obj, index) in GET_LIST" :key="index">
              <a @click="btnDetail(obj)">
                <dl>
                  <dd class="img">
                    <img :src="obj.MAIN_IMG" />
                  </dd>
                  <dt>{{ obj.title }}</dt>
                  <dd>{{ obj.createdAt | date }}</dd>
                </dl>
              </a>
            </li>
          </ul>
        </div>
        <router-view />
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import pm from "../common/protocolManager";
export default {
    data: () => ({
    message: "NewsList.vue",
    isAdmin: false,
    }),
  methods: {
    btnDetail(obj) {
      this.$router.push({
        path: `/notice/detail`,
        query: {
          id: obj._id,
          // 게시판 타입 = 0 : 공지사항, 1 : 소식,
          type: obj.type,
        }
      });
    },
    btnNoticeWrite() {
      console.log('btnNoticeWrite');
      this.$router.push({path : `/notice/NoticeWritePopup`,
        query: {
          // id: '63b381bb12e1a0174b6cce42',
          // 게시판 타입 = 0 : 공지사항, 1 : 소식,
          type: 1,
        }
      });
    },
    checkAdmin() {
      let url = "isAdmin";
      pm.get(url)
        .then(result => {
          console.log('isAdmin = true');
          this.isAdmin = true;
        })
        .catch(err => {
          console.log('isAdmin = err');
          this.isAdmin = false;
          if (localStorage.authToken) {
            localStorage.removeItem("authToken");
          }
        });
    },

  },
  computed: {
    ...mapGetters(["getNewsList"]),
      IS_MOBILE() {
          return this.$root.$data.isMobileMode;
    },
      GET_LIST() {
      return this.getNewsList;
    }
  },
  destroyed() { },
  mounted() {
    this.checkAdmin();
  },
  created() {
    console.log("created - " + this.message);

  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub02/NewsList.vue